import React from 'react';
import styles from './styles';

const PatientData = props => {
  const dataPoints = {
    conditions: 'Conditions',
    nct_id: 'NCTs',
    age: 'Age',
    firstName: 'Name',
    email: 'Email',
    gender: 'Gender',
    pscore: 'ECOG Status',
    mutationsIn: 'Mutations: Eligible',
    mutationsOut: 'Mutations: Absent',
    created_date: 'Latest Entry',
    broadcastCount: 'Sent Broadcasts',
    lastBroadcast: 'Last Sent Broadcast'
  }
  return (
    <div>
      {Object.keys(dataPoints).map((key, index) => {
        if(props.data[key]) return <React.Fragment key={index}>
            <h5 style={styles.subTitle}>{dataPoints[key]}</h5>
            <span>{props.data[key]}</span>
          </React.Fragment>
        }
      )}
    </div>
  )
}

export default PatientData;
